import { HelmetDexteel } from "@dexteel/mesf-core";
import { PassIdsManager } from "./components/PassIdsManager";

export const PassIdsPage = () => {
	return (
		<>
			<HelmetDexteel title="Pass IDs" />
			<PassIdsManager />
		</>
	);
};
